import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RestTwoToneSvg from "@ant-design/icons-svg/es/asn/RestTwoTone";
import AntdIcon from "../components/AntdIcon";
var RestTwoTone = function RestTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RestTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RestTwoTone.displayName = 'RestTwoTone';
}
export default /*#__PURE__*/React.forwardRef(RestTwoTone);